<!-- eslint-disable vue/no-unused-vars -->

<template>
  <div class="settlement-listing">
    <b-card no-body>
      <b-card-header class="py-3 px-3">
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="mb-0">Settlement Details</h3>
          <!-- <p class="text-primary cursor-pointer text-xs">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 448 512">
              <path fill="currentColor"
                d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
            </svg>
            Add Settlement
          </p> -->
        </div>
      </b-card-header>

      <div class="card-table-simple">
        <b-table-simple bordered responsive>
          <b-thead>
            <b-tr>
              <b-th class="text-center">#</b-th>
              <b-th>Loan Facility</b-th>
              <b-th>Settlement<br> Status</b-th>
              <b-th>Bank</b-th>
              <b-th>Account<br>No.</b-th>
              <b-th>Settlement<br>Amount (RM)</b-th>
              <b-th>Current<br>Outstanding (RM)</b-th>
              <b-th>Merchant<br>Solution (RM)</b-th>
              <b-th>Payment<br>Type</b-th>
              <b-th>Paid<br>Date</b-th>
              <b-th>Remarks</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(data, index) in tableData" :key="index">
              <b-td class="text-center">{{ index + 1 }}</b-td>
              <b-td>
                <!-- <b-form-select v-model="data.loan_facility" @change="createOrUpdate(data, index)">
                  <b-form-select-option v-for="item in tables.loanFacilities" :key="item.key" :value="item.value">
                    {{ item.key }}
                  </b-form-select-option>
                </b-form-select> -->
                <b-form-input v-model="data.loan_facility" @blur="createOrUpdate(data, index)"></b-form-input>
              </b-td>
              <b-td>
                <b-form-select v-model="data.status" @change="createOrUpdate(data, index)">
                  <b-form-select-option v-for="item in settlementStatusList" :key="item.status" :value="item.status">
                    {{ item.status }}
                  </b-form-select-option>
                </b-form-select>
              </b-td>
              <b-td>
                <b-form-select v-model="data.bank_id" @change="createOrUpdate(data, index)">
                  <b-form-select-option v-for="item in tables.banks" :key="item.bank_id" :value="item.bank_id">
                    {{ item.name }}
                  </b-form-select-option>
                </b-form-select>
              </b-td>
              <b-td><b-form-input v-model="data.account_no" @blur="createOrUpdate(data, index)"></b-form-input></b-td>
              <b-td>
                <CurrencyInput className="text-right" v-model="data.settlement_amt" @blur="createOrUpdate(data, index)"
                  :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
              </b-td>
              <b-td>
                <CurrencyInput className="text-right" v-model="data.current_outstanding"
                  @blur="createOrUpdate(data, index)"
                  :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
              </b-td>
              <b-td>
                <CurrencyInput className="text-right" v-model="data.merchant_solution"
                  @blur="createOrUpdate(data, index)"
                  :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
              </b-td>
              <b-td>
                <b-form-select v-model="data.payment_type" @change="createOrUpdate(data, index)">
                  <b-form-select-option v-for="item in tables.paymentTypes" :key="item.key" :value="item.value">
                    {{ item.key }}
                  </b-form-select-option>
                </b-form-select>
              </b-td>
              <b-td width="150">
                <el-date-picker v-model="data.paid_date" type="date" placeholder="Pick a day"></el-date-picker>
              </b-td>
              <b-td><b-form-input v-model="data.remarks" @blur="createOrUpdate(data, index)"></b-form-input></b-td>
              <b-td class="cursor-pointer">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" style="cursor: pointer">
                    <p class="el-dropdown-link mb-0 top-line">
                      <b-icon icon="three-dots-vertical"></b-icon>
                    </p>
                    <el-dropdown-menu slot="dropdown">
                      <!-- <el-dropdown-item>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                          <path fill="#13663E"
                            d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
                        </svg>
                        View Change Log
                      </el-dropdown-item> -->
                      <el-dropdown-item @click.native="removeItem(data.id, index)">
                        <span class="text-danger">
                          <!-- Trash-Can Icon -->
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                            <path fill="#DF3030"
                              d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
                          </svg>
                          Delete
                        </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="13">
                <p class="text-primary cursor-pointer" @click="addNew">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 448 512">
                    <path fill="currentColor"
                      d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
                  </svg>
                  Add
                </p>
              </b-td>
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr class="bg-warning">
              <b-td colspan="6">Total</b-td>
              <b-td class="text-right">RM {{ total_amt.settlement_amt | moneyFormatter }}</b-td>
              <b-td class="text-right">RM {{ total_amt.current_outstanding | moneyFormatter }}</b-td>
              <b-td class="text-right">RM {{ total_amt.merchant_solution | moneyFormatter }}</b-td>
              <b-td colspan="4"></b-td>
            </b-tr>
          </b-tfoot>
        </b-table-simple>
      </div>

    </b-card>
  </div>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button, DatePicker } from 'element-ui';
;
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import { BasePagination } from '@/components';
import clientPaginationMixin from '@/assets/js/clientPaginationMixin';
import debounce from 'lodash.debounce';
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import SmsDrawer from '@/views/Sms/SmsDrawer';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import CurrencyInput from '@/components/CurrencyInput';

export default {
  name: 'all-customer-table',
  mixins: [clientPaginationMixin],
  components: {
    // BasePagination,
    // AllCustomerFilter,
    // SmsDrawer,
    // MessagingBoxButton,
    CurrencyInput,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      propsToSearch: ['customer_name'],
      tableData: [],
      tables: {
        banks: [],
        loanFacilities: [
          {
            key: "Legal/Stamp Duty Fees",
            value: "Legal/Stamp Duty Fees"
          },
          {
            key: "Insurance Premium",
            value: "Insurance Premium"
          },
          {
            key: "Personal Loan",
            value: "Personal Loan"
          }
        ],
        paymentTypes: [
          {
            key: "Transfer",
            value: "Transfer"
          }
        ]
      },
      currentPage: 1,
      mode: 'listing',
      selectedRows: [],
      searchText: '',
      debouncedHandler: '',
      TableColumn: [{
        type: 'selection'
      }],
      isTableLoading: false,
      isFixed: true,
      sub_status: '',
      main_status: [],
      customerStatus: '',
      searchCustomerDeboundHandler: '',
      searchQuery: '',
      settlementStatusList: [
        {
          status_id: 1,
          status: 'Pending',
        },
        {
          status_id: 2,
          status: 'Done',
        },
        {
          status_id: 3,
          status: 'Cancelled',
        },
      ],
      total_amt: {
        settlement_amt: 0,
        current_outstanding: 0,
        merchant_solution: 0,
      }
    };
  },
  computed: {
    ...mapState(useCustomerStore, ['activeCustomer']),
  },
  created() {
    this.getBanks();
    this.getList();
  },
  methods: {
    ...mapActions(useCommonStore, ['getTables']),
    ...mapActions(useLoanCaseStore, ['getSettlementsList', 'createOrUpdateSettlement','deleteSettlement']),
    getList() {
      const params = {
				search:{
					customer_id: this.activeCustomer.id
				}
      }
      this.getSettlementsList(params).then((resp) => {
         
        this.tableData = resp.data;
        this.refreshTotal();
      });
    },
    getBanks() {
      this.getTables('banks').then(resp => {
        this.tables.banks = resp.banks;
      });
    },
    addNew() {
      const newData = {
        customer_id: this.activeCustomer.id,
        loan_facility: '',
        status: 'Pending',
        advisor: '',
        bank_id: '',
        account_no: '',
        settlement_amt: 0,
        current_outstanding: 0,
        merchant_solution: 0,
        payment_type: '',
        paid_date: '',
        remarks: '',
      };
      this.tableData.push(newData);
    },
    removeItem(id, index) {
      // Check if the index is within the array bounds
      if (index >= 0 && index < this.tableData.length) {
        // Use splice to remove the item at the specified index
        this.tableData.splice(index, 1);
        this.delete(id);
      }
    },
    paginationChanged(page) {
      this.pagination.currentPage = page
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    getClockIconColor(tracking_color) {
      switch (tracking_color) {
        case 'green':
          return 'text-success'; // Change to green color class
          break;
        case 'yellow':
          return 'text-warning'; // Change to yellow color class
          break;
        case 'red':
          return 'text-danger'; // Change to red color class
          break;
        default:
          return 'text-dark'; // Change to dark color class
          break;
      }
    },
    filterByMainStatus() {
    },
    filterAllCustomer(event) {
    },
    updateCustomerStatus(status, status_id) {
    },
    getStatusColor(status) {
      switch (status) {
        case 'Pending':
          return '#DC9A0F'
          break;
        case 'Done':
          return '#0BC196'
          break;
        default:
          break;
      }
    },
    createOrUpdate(item, index) {
      this.createOrUpdateSettlement(item).then(resp => {
        this.tableData[index].id = resp.data.id;
      });
      this.refreshTotal();
    },
    delete(id) {
      this.deleteSettlement(id);
      this.refreshTotal();
    },
    refreshTotal() {
      this.total_amt.settlement_amt = 0;
      this.total_amt.current_outstanding = 0;
      this.total_amt.merchant_solution = 0;
      this.tableData.forEach(el => {
        this.total_amt.settlement_amt += el.settlement_amt;
        this.total_amt.current_outstanding += el.current_outstanding;
        this.total_amt.merchant_solution += el.merchant_solution;
      })
    }
  }
}
</script>